import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import homeIcon from '../../assets/navIcons/home.svg';
import infoIcon from '../../assets/navIcons/infoCircle.svg';
import profissionaisIcon from '../../assets/navIcons/pessoas.svg';
import espacoIcon from '../../assets/navIcons/building.svg';
import contatoIcon from '../../assets/navIcons/contact.svg';
import servicoIcon from '../../assets/navIcons/puzzlepiece.svg';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { href: '#home', label: 'Home', icon: homeIcon },
    { href: '#sobre', label: 'Sobre', icon: infoIcon },
    { href: '#servicos', label: 'Serviços', icon: servicoIcon },
    { href: '#profissionais', label: 'Equipe', icon: profissionaisIcon },
    { href: '#espaco', label: 'Espaço', icon: espacoIcon },
    { href: '#contato', label: 'Contato', icon: contatoIcon },
  ];

  const navigate = useNavigate();

  const handleNavigation = (href) => {
    if (window.location.pathname !== '/') {
      navigate(`/${href}`);
    } else {
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
        window.history.replaceState(null, '', href);
      }
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
  
    if (isMobileMenuOpen) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }
  
    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      <div
        className={`mobile-menu-icon nav-icon3 ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={toggleMobileMenu}
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className="navbar-desktop">
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              <a
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation(item.href);
                }}
              >
                <img className="nav-icon" src={item.icon} alt={`${item.label} Icon`} />
                <span className="nav-item">{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className={`mobile-dropdown ${isMobileMenuOpen ? 'open visible' : ''}`}>
        {menuItems.map((item, index) => (
          <a
            key={index}
            href={item.href}
            onClick={(e) => {
              e.preventDefault();
              setIsMobileMenuOpen(false);
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  handleNavigation(item.href);
                });
              });
            }}
          >
            {item.label}
          </a>
        ))}
      </div>
    </>
  );
}

export default Navbar;
